import React from 'react';

// components
import {Button} from '@mui/joy';
import {CustomModal} from '../CustomModal';

// helpers
import {useTranslation} from 'react-i18next';

// styles
import {TextDefault} from '../../styles';

// types
type Props = {
  isOpen: boolean;
  message: string;
};

const ConcurrencyResolutionModal = ({isOpen, message}: Props) => {
  const {t} = useTranslation();

  return (
    <CustomModal
      isOpen={isOpen}
      title={t('global_information')}
      actionButtons={
        <Button size="lg" onClick={() => location.reload()}>
          {t('global_update')}
        </Button>
      }>
      <TextDefault>{message}</TextDefault>
    </CustomModal>
  );
};

export default ConcurrencyResolutionModal;
